export function trimValues<T extends object>(values: T): T {
  if (values == null) {
    return values;
  }

  if (typeof values !== 'object') {
    return values;
  }

  return Object.fromEntries(
    Object.entries(values).map(([key, value]) => {
      if (typeof value === 'object' && value !== null) {
        return [key, trimValues(value)];
      }

      if (typeof value === 'string') {
        return [key, value.trim()];
      }

      return [key, value];
    }),
  ) as T;
}
